import * as React from "react";
const SvgFiRrGunSquirt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-gun-squirt_svg__a)">
      <path
        fill="#062147"
        d="M23 6h-1.1A5.01 5.01 0 0 0 17 2H5V1a1 1 0 1 0-2 0v1.424A5 5 0 0 0 0 7c0 1.909 1.088 3.552 2.665 4.394L.108 20.333a2.87 2.87 0 0 0 .48 2.524A2.87 2.87 0 0 0 2.89 24c1.29 0 2.435-.868 2.781-2.105L6.783 18H10v1a1 1 0 1 0 2 0v-4a1 1 0 1 0-2 0v1H7.354l1.142-4H17a5.01 5.01 0 0 0 4.9-4h1.1A1 1 0 1 0 23 6M3.747 21.351a.89.89 0 0 1-.856.649.87.87 0 0 1-.708-.351.87.87 0 0 1-.15-.772l2.552-8.919c.14.012.274.042.416.042h1.416zM17 10H5c-1.654 0-3-1.346-3-3s1.346-3 3-3h12c1.654 0 3 1.346 3 3s-1.346 3-3 3m-4-3a1 1 0 0 1-1 1H5a1 1 0 1 1 0-2h7a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-gun-squirt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGunSquirt;
